import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { WebEDIErrorsServiceSingleton } from './serviceSingleton';

export const useFocusErrorOnMount = () => {
  const location: { state?: { focusOnField?: { fieldPath: string } } } = useLocation();
  const { focusOnField } = location.state || {};
  const hasFocusedRef = useRef(false);

  useEffect(() => {
    // Mount-only. The ref avoidsre-fire and yanking the user mid-edit
    if (hasFocusedRef.current) {
      return;
    }
    if (focusOnField?.fieldPath) {
      const error = WebEDIErrorsServiceSingleton.getFirstItemByFieldPath(focusOnField.fieldPath);
      if (error) {
        WebEDIErrorsServiceSingleton.setCurrentItem(error);
        hasFocusedRef.current = true;
      }
    }
  }, [focusOnField]);
};
